// extracted by mini-css-extract-plugin
module.exports = {"partScoreAndNarrative":"style-module__partScoreAndNarrative___2aS7j","detractor":"style-module__detractor___2KAGL","promoter":"style-module__promoter___20qiJ"};